import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['label']

  optionClick(event) {
    event.preventDefault()
    let target = event.currentTarget
    let detail = {
      type: target.dataset.type,
      name: target.dataset.name,
      value: target.value === undefined ? target.dataset.value : target.value
    }
    this.dispatch('select-option', { detail })
    if (this.hasLabelTarget) {
      this.labelTarget.innerHTML = ''
      if (target.children.length === 0) {
        this.labelTarget.textContent = target.textContent
      } else {
        for (let c of target.children) {
          this.labelTarget.append(c.cloneNode(true))
        }
      }
    }
  }
}
